import { render, staticRenderFns } from "./LeadTodayAppointment.vue?vue&type=template&id=462238c0&"
import script from "./LeadTodayAppointment.vue?vue&type=script&lang=js&"
export * from "./LeadTodayAppointment.vue?vue&type=script&lang=js&"
import style0 from "./LeadTodayAppointment.vue?vue&type=style&index=0&id=462238c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports